module.exports = __webpack_public_path__ + "static/apple-touch-icon-5b393e7ad8329fabe7f0ff0134f965b5.png";